import React from 'react';
import Stylesheet from './Tables.module.css';
import Table from '../../../components/Table/Table';
import {user} from '@enigma/core/services';

const Tables = (props) => {
    document.title = "Settings - Tables";
    return (
        <div className={Stylesheet.Container}>
            <div className={Stylesheet.Header}>
                <h4>manage tables</h4>
                <h5>create and manage tables. all created tables will be visible to&nbsp;
                    all registered users, set table descriptions for clearity.
                </h5>
            </div>
            <div className={Stylesheet.Collection}>
                <Table collection='tables' basic
                deleteText='remove table'
                metadata={{id: "tables", name: "tables"}}
                lock={!user.isEmailVerified} 
                schema={[{
                    title: "table name", 
                    name: "name", 
                    type: "string", 
                    required: true, 
                    unique: true, 
                    default: "unnamed"
                },{
                    title: "table description", 
                    name: "description", 
                    type: "string", 
                    required: true, 
                    unique: false
                }]} addText='create new table' />
            </div>
        </div>
    )
}

export default Tables;